module.exports = __webpack_public_path__ + "images/3c5574b5e1fe1470a49f46bc08828ef4.svg";